import { Component } from '@verndale/core';
import axios from 'axios';
import qs from 'qs';
import ResourceCardTemplate from '../../html/components/cards/resource-card.hbs';

class FilteredResourceCards extends Component {
  setupDefaults() {
    this.dom = {
      tagsContainer: this.el.querySelector('.filtered-resource-cards__tags'),
      listing: this.el.querySelector('.grid'),
      viewAll: this.el.querySelector('.resource-card--view-all'),
      viewAllLink: this.el.querySelector('.resource-card--view-all a')
    };

    this.viewAllBaseUrl = this.dom.viewAllLink.getAttribute('href');
    this.overrideId = this.el.dataset.id;
    this.getEndpointData();
  }

  handleTagSelect() {
    const urlParams = new URLSearchParams();

    const tagsChecked = [...this.dom.tags]
      .filter(t => t.checked)
      .map(c => c.value);

    tagsChecked.forEach(val => urlParams.append('tag', val));

    let filteredResults = [];
    if (tagsChecked.length > 0)
      filteredResults = this.initialResults.filter(r => {
        if (tagsChecked.some(t => r.tags?.includes(t))) return r;
        return null;
      });
    else filteredResults = this.initialResults;

    this.el.classList.add('filtered-resource-cards--loading');
    const listing = filteredResults
      .map(a => ResourceCardTemplate(a))
      .slice(0, 7)
      .join('');

    this.dom.listing.innerHTML = `${listing}`;
    this.dom.listing.appendChild(this.dom.viewAll);
    this.el.classList.remove('filtered-resource-cards--loading');

    if (urlParams.toString().length > 0) {
      this.dom.viewAllLink.setAttribute(
        'href',
        `${this.viewAllBaseUrl}?${urlParams}`
      );
    } else this.dom.viewAllLink.setAttribute('href', `${this.viewAllBaseUrl}`);
  }

  async getEndpointData() {
    const { endpoint } = this.el.dataset;
    const id = this.overrideId;

    this.el.classList.add('filtered-resource-cards--loading');

    const { data } = await axios.get(endpoint, {
      params: {
        id
      },
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    });

    const listing = data.results
      .map(a => ResourceCardTemplate(a))
      .slice(0, 7)
      .join('');

    this.dom.listing.innerHTML = `${listing}`;
    this.dom.listing.appendChild(this.dom.viewAll);
    this.el.classList.remove('filtered-resource-cards--loading');

    if (!this.initialized) {
      this.el.classList.add('filtered-resource-cards--initialized');
      this.initialized = true;
    }
    this.insertTagsMarkup(data);
    this.dom.tags = [
      ...this.el.querySelectorAll('.filtered-resource-cards__tag input')
    ];
    this.dom.tags.forEach(tag =>
      tag.addEventListener('change', this.handleTagSelect.bind(this))
    );
    this.dom.viewAllLink.setAttribute('href', `${this.viewAllBaseUrl}`);
    this.initialResults = data.results;
  }

  insertTagsMarkup(data) {
    let divGroup;
    data.tags.forEach((tag, i) => {
      const numberOfResultsForTag = data.results.filter(a =>
        a.tags.includes(tag)
      ).length;
      if (numberOfResultsForTag > 0) {
        if (i % 5 === 0) divGroup = document.createElement('div');
        const tagEl = document.createElement('div');
        tagEl.classList.add('filtered-resource-cards__tag');
        tagEl.innerHTML = `
        <label>
        <input type="checkbox" value="${tag}">
        <span>${tag}</span>
        </label>
      `;
        divGroup.appendChild(tagEl);
        if (i % 5 === 0) this.dom.tagsContainer.appendChild(divGroup);
      }
    });
  }
}

export default FilteredResourceCards;
